import {connect} from 'react-redux'
import React, {Component} from 'react'
import moment from 'moment'
import request from 'superagent'
import MetronicIndex from '../layout/metronic/index'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import BootstrapTable from 'react-bootstrap-table-next'
import apis from '../helper/api'
import localdata from '../helper/localdata'
import action from '../helper/action'
import do_action from '../action'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import {history} from '../helper/history'
import Modal from 'react-responsive-modal'

class MAgentBatchKomisi extends Component {

    constructor(props) {
        super(props);
        this.state = {year_sel: '2020', month_sel: '1', s_year_sel: '2020', s_month_sel: '1', batch_file_obj: '', batch_file_name: '', url_download: '', total_page: 0};
        this.batch_file_input_changed = this.batch_file_input_changed.bind(this);
        this.on_request_data = this.on_request_data.bind(this);
        this.on_submit_data = this.on_submit_data.bind(this);
        this.on_request_data_per_page = this.on_request_data_per_page.bind(this);
        this.on_request_data_per_page_reset = this.on_request_data_per_page_reset.bind(this);
    }

    componentDidMount() {
        this.props.update_current_page('batch-realisasi-komisi')
    	let now = moment().toDate()
    	this.setState({month_sel: now.getMonth(), s_month_sel: now.getMonth()})
    }

    batch_file_input_changed = (event) => {
    	let b_file = event.target.files[0]
        util.log(b_file)
        if (b_file === undefined) {return}
        this.setState({batch_file_name: b_file.name, batch_file_obj: b_file})
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login')
            }).catch((err) => {
                util.log("error: ", err)
            })
        } else {
            let msg = "Error: " + err.code
            if (err.message !== undefined) {
                msg = err.message
            }
            swal("Ups!", msg, "warning")
        }
    }

    on_btn_reset() {
        this.file_input.value = ""
        this.setState({batch_file_name:'',batch_file_obj:''})
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_select_change(e) {
    	this.setState({[e.target.id]: e.target.value})
        if (e.target.id === 'month_sel') {
            this.setState({s_month_sel:  e.target.value})
        } else if (e.target.id === 'year_sel') {
            this.setState({s_year_sel:  e.target.value})
        }
    }

    on_request_data_per_page() {
        if (this.state.flag_processing) return
        let self = this
        var cboxes = document.getElementsByName('download-pages[]')
        var len = cboxes.length;
        for (var i = 0; i < len; i++) {
            util.log(i + (cboxes[i].checked ? 'checked' : 'unchecked') + cboxes[i].value);
            if (cboxes[i].checked) {
                window.open(self.state.url_download + "?page=" + cboxes[i].value);
            }
        }
    }

    on_request_data_per_page_reset() {
        this.setState({url_download: '', total_page: ''});
    }

    on_request_data() {
    	if (this.state.flag_processing) return
    	let self = this
        let body = {
            "session_id" : this.props.session,
            "year" : this.state.year_sel,
            "month" : this.state.month_sel
        }
        let url = apis.request_batch_realisasi_komisi
        this.setState({flag_processing: true})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            if (payload.results !== null) {
                                if (payload.results.total_page > 1) {
                                    self.setState({url_download: payload.results.url_download, total_page: payload.results.total_page})
                                } else {
                                    window.open(payload.results.url_download);
                                }
                            } else {
                                swal("Error!", "Data tidak dapat di download. Hubungi Admin untuk informasi lebih lanjut")
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                    }
                }
                self.setState({flag_processing: false})
            })
    }

    on_submit_data() {
    	if (this.state.batch_file_obj === undefined) return
        let self = this
        swal({
            title: "Konfirmasi",
            text: "Apakah Anda yakin untuk melanjutkan realisasi komisi ini?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((sure) => {
            if (sure) {
                let url = apis.submit_batch_realisasi_komisi
                if (url.length !== 0) {
                    self.setState({tx_flag_cari_processing: true})
                    request.post(url)
                        .attach('fileupload', this.state.batch_file_obj)
                        .field('session_id', this.props.session)
                        .field('year', this.state.s_year_sel)
                        .field('month', this.state.s_month_sel)
                        .then(res => {
                            util.log(res)
                            if (res.ok) {
                                let failed = ""
                                if (res.statusCode === 200) {
                                    let payload = res.body
                                    if (payload.status === "OK") {
                                        swal(payload.error.message, payload.display_message, "success")
                                        self.on_btn_reset()
                                    } else {
                                        failed = payload.error.message
                                    }
                                } else {
                                    failed = res.statusCode
                                }
                                if (failed.length !== 0) {
                                    swal("Gagal", failed, "error")
                                }
                            }
                            self.setState({tx_flag_cari_processing: false})
                        })
                } else {
                    swal("Format File Salah", "Periksa kembali format file input, pastikan sesuai dengan aturan yang telah kita buat.", "warning")
                }
            } else {
                // no-op
            }
        })
    }

    createPages = () => {
        let pages = []
        let total = this.state.total_page
        for (let i = 0; i < total; i++) {
            pages.push(<div className="">
                <div className="col m--align-left m-login__form-left" style={{paddingLeft: 0}}>
                    <label className="m-checkbox  m-checkbox--dark" style={{fontWeight: 500}}>
                        <input type="checkbox" name="download-pages[]" defaultChecked="true" value={i + 1} />
                        {i + 1}
                    <span></span>
                    </label>
                </div>
            </div>)
        }
        return pages
    }

    render() {
        let self = this
        return (
            <div className="row">

            	<div className="col-lg-6">
                    <div className="m-portlet">

                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        (1) Download Data Realisasi Komisi
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="m-portlet__body" style={{maxHeight: '1000px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="form-group m-form__group" style={{marginBottom: '5px'}}>
                                {this.state.url_download === '' ?
                                <div>
                                    <div className="row">
                                        <label className="col-2 col-form-label" style={{fontWeight:600}}>
                                            Tahun
                                        </label>
                                        <div className="col-10" style={{margin: 'auto 0'}}>
                                            <select className="form-control m-input" id="year_sel" value={this.state.year_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                <option value="2018"> 2018 </option>
                                                <option value="2019"> 2019 </option>
                                                <option value="2020"> 2020 </option>
                                                <option value="2021"> 2021 </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row" style={{marginTop:'10px'}}>
                                        <label className="col-2 col-form-label" style={{fontWeight:600}}>
                                            Bulan
                                        </label>
                                        <div className="col-10" style={{margin: 'auto 0'}}>
                                            <select className="form-control m-input" id="month_sel" value={this.state.month_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                <option value="1"> Januari </option>
                                                <option value="2"> Februari </option>
                                                <option value="3"> Maret </option>
                                                <option value="4"> April </option>
                                                <option value="5"> Mei </option>
                                                <option value="6"> Juni </option>
                                                <option value="7"> Juli </option>
                                                <option value="8"> Agustus </option>
                                                <option value="9"> September </option>
                                                <option value="10"> Oktober </option>
                                                <option value="11"> November </option>
                                                <option value="12"> Desember </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row" style={{marginTop:'40px'}}>
                                        <div className="col-7">
                                            <button type="submit" 
                                                onClick={this.on_request_data} 
                                                className={this.state.flag_processing ? 'btn btn-accent m-btn m-btn--air m-btn--custom m-loader m-loader--light m-loader--right' : 'btn btn-accent m-btn m-btn--air m-btn--custom'}>
                                                Download
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                : 
                                <div>
                                    <FormGroup>
                                        <div style={{}}>
                                            <label className="col-form-label" style={{fontWeight:600}}>
                                                Data ini lebih dari satu page (max data agen per page 1000): 
                                            </label>
                                        </div>
                                        {this.createPages()}
                                        <div style={{marginTop:'10px'}}>
                                            <button type="submit" 
                                                onClick={this.on_request_data_per_page} 
                                                className={this.state.flag_processing ? 'btn btn-accent m-btn m-btn--air m-btn--custom m-loader m-loader--light m-loader--right' : 'btn btn-accent m-btn m-btn--air m-btn--custom'}>
                                                Download per Page
                                            </button>
                                            &nbsp;
                                            <button type="button" 
                                                onClick={this.on_request_data_per_page_reset} 
                                                className='btn btn-secondary m-btn m-btn--air m-btn--custom'>
                                                Reset
                                            </button>
                                        </div>
                                    </FormGroup>
                                </div>
                                }
                                <div className="row" style={{marginTop:'40px',marginLeft:'5px',marginRight:'5px'}}>
                                	<span style={{fontWeight:600}}>Note:</span><br/>
                            		<span>- Download data laporan bulanan yang berformat excell dengan memasukkan bulan dan tahun laporan.<br/>- Edit beberapa data realisasi langsung pada file excell yang sudah anda download. Warna hijau silakan diedit sesuai kebutuhan untuk proses realisasi termasuk perhitungan potongan komisi. Warna biru sifatnya optional, boleh diedit atau tidak.<br/>- Setelah selesai edit, kemudian submit dan upload pada form yang sudah disediakan sebelah kanan.</span>
                            	</div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="m-portlet">
                        
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        (2) Submit Data Realisasi Komisi
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="m-portlet__body" style={{maxHeight: '1000px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="form-group m-form__group" style={{marginBottom: '5px'}}>
                            	<FormGroup>
	                                <label style={{fontWeight: 600}}>
	                                    File Input Data Realisasi Komisi:
	                                </label>
	                                <div className="input-group">
	                                    <div className="input-group">
	                                    	<input disabled className="form-control m-input" type="text" name="batch_file_name" value={this.state.batch_file_name} />
	                                    	<span className="input-group-btn" onClick={(e) => document.getElementById("batch_file_input").click()}>
	    										<button className="btn btn-primary" type="button">
	    											Browse
	    										</button>
	    									</span>
	                                	</div>
	                                    <input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" id="batch_file_input" name="batch_file_input" 
	                                            onChange={this.batch_file_input_changed} 
	                                            style={{display:'none'}} 
	                                            ref={ref=> this.file_input = ref}/>
	                                </div>

                                    {this.state.batch_file_obj.length !== 0 ? 
                                        <React.Fragment>
                                        <div className="row" style={{margin:'20px 0px 15px 0px'}}>
                                            <span style={{fontWeight:600}}>Data realisasi komisi periode {util.get_month_name(this.state.s_month_sel)}, {this.state.s_year_sel} (Ubah tahun dan tanggal berikut jika periode salah)</span>
                                        </div>
                                        <div className="row">
                                            <label className="col-2 col-form-label" style={{fontWeight:600}}>
                                                Tahun
                                            </label>
                                            <div className="col-10" style={{margin: 'auto 0'}}>
                                                <select className="form-control m-input" id="s_year_sel" value={this.state.s_year_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                    <option value="2018"> 2018 </option>
                                                    <option value="2019"> 2019 </option>
                                                    <option value="2020"> 2020 </option>
                                                    <option value="2021"> 2021 </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'10px'}}>
                                            <label className="col-2 col-form-label" style={{fontWeight:600}}>
                                                Bulan
                                            </label>
                                            <div className="col-10" style={{margin: 'auto 0'}}>
                                                <select className="form-control m-input" id="s_month_sel" value={this.state.s_month_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                    <option value="1"> Januari </option>
                                                    <option value="2"> Februari </option>
                                                    <option value="3"> Maret </option>
                                                    <option value="4"> April </option>
                                                    <option value="5"> Mei </option>
                                                    <option value="6"> Juni </option>
                                                    <option value="7"> Juli </option>
                                                    <option value="8"> Agustus </option>
                                                    <option value="9"> September </option>
                                                    <option value="10"> Oktober </option>
                                                    <option value="11"> November </option>
                                                    <option value="12"> Desember </option>
                                                </select>
                                            </div>
                                        </div>
                                        </React.Fragment>
                                    : ''}

	                                <div className="row" style={{marginTop:'20px'}}>
	                                    <div className="col-7">
	                                        <button type="submit" 
	                                            onClick={this.on_submit_data} 
	                                            className={this.state.flag_processing_submit ? 'btn btn-accent m-btn m-btn--air m-loader m-loader--light m-loader--right' : 'btn btn-accent m-btn m-btn--air'}>
	                                            Submit
	                                        </button>
	                                    </div>
	                                </div>
	                                <div className="row" style={{marginTop:'40px',marginLeft:'5px',marginRight:'5px'}}>
	                                	<span style={{fontWeight:600}}>Note:</span><br/>
	                            		<span>Periksa secara hati-hati data realisasi yang akan Anda submit, jika terdapat kesalahan atau ketidakcocokan data silakan untuk hubungi Admin.</span>
	                            	</div>
	                            </FormGroup>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }

}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val))
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(MAgentBatchKomisi)



// WEBPACK FOOTER //
// ./src/component/magent_batch_komisi.js